import { render, staticRenderFns } from "./ClientSegments.vue?vue&type=template&id=198b645a&scoped=true&"
import script from "./ClientSegments.vue?vue&type=script&lang=js&"
export * from "./ClientSegments.vue?vue&type=script&lang=js&"
import style0 from "./ClientSegments.vue?vue&type=style&index=0&id=198b645a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198b645a",
  null
  
)

export default component.exports